// extracted by mini-css-extract-plugin
export default {"circleCounter":"circle_counter-module___circleCounter___dce673bb"};